import { render, staticRenderFns } from "./DashboardUnread.vue?vue&type=template&id=6e5867f9"
import script from "./DashboardUnread.vue?vue&type=script&lang=js"
export * from "./DashboardUnread.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports